export default "__VITE_ASSET__EEuRGVMO__"